import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function DeleteFile delete user's signature
 * @param {Object} payload {instance, account}
 */
export const DeleteFile = (payload) => {
  payload.instance
    .acquireTokenSilent({ ...silentRequest, account: payload.account })
    .then((tokenResponse) => {
      axios.delete(API_URL + "/signatures", {
        headers: {
          Authorization: "Bearer " + tokenResponse.accessToken,
        },
      });
    })
    .catch((error) => {
      console.log(error);
      payload.instance.acquireTokenRedirect(silentRequest);
    });
};
